export default __webpack_public_path__ + "img/jtc/jtc4_480.jpg";